import type React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { RiArrowLeftSLine } from '@remixicon/react'

interface BreadcrumbItem {
    label: string
    path: string
}

interface BreadcrumbProps {
    title?: string
    subtitle?: string
    items: BreadcrumbItem[]
    separator?: React.ReactNode
    showGoBack?: boolean
    children?: React.ReactNode
    className?: string
}

const Breadcrumb = ({
    items,
    title,
    subtitle,
    separator,
    showGoBack = true,
    children,
    className,
}: BreadcrumbProps) => {
    const navigate = useNavigate()

    return (
        <nav className={`${className}`}>
            <ol className="flex gap-5">
                {items.map(({ path, label }, index) => (
                    <div className="flex items-center gap-5" key={index}>
                        <li>
                            <Link
                                className={`text-[#475569] ${
                                    items.length == index + 1 && 'font-semibold'
                                }`}
                                to={path}
                            >
                                {label}
                            </Link>
                        </li>

                        {items.length !== index + 1 && separator}
                    </div>
                ))}
            </ol>
            <div className="flex items-center justify-between">
                <div>
                    {title !== undefined && (
                        <div className="flex items-center gap-4 my-1">
                            {showGoBack && (
                                <button
                                    onClick={() => navigate(-1)}
                                    className="text-gray-500 hover:text-gray-700 transition-colors"
                                    aria-label="Atrás"
                                >
                                    <RiArrowLeftSLine size={24} />
                                </button>
                            )}
                            <h2 className="text-ebony-950 text-3xl font-bold">
                                {title}
                            </h2>
                        </div>
                    )}
                    {subtitle !== undefined && (
                        <h3 className="text-gray-500 text-lg">{subtitle}</h3>
                    )}
                </div>
                {children}
            </div>
        </nav>
    )
}

export default Breadcrumb
